import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { toast, ToastContainer } from "react-toastify";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await login(email, password);

    if (result.success) {
      navigate("/dashboard");
    } else {
      toast.error(result.message);
    }
  };

  useEffect(() => {
    document.title = "Giriş Yap | LEVELUP CRM";

    if (localStorage.getItem("token")) {
      navigate("/dashboard");
    }
  }, []);

  return (
    <>
      <main class="auth-cover-wrapper">
        <div class="auth-cover-content-inner">
          <div class="auth-cover-content-wrapper">
            <div class="auth-img">
              <img
                src="assets/images/auth/auth-cover-login-bg.svg"
                alt=""
                class="img-fluid"
              />
            </div>
          </div>
        </div>
        <div class="auth-cover-sidebar-inner">
          <div class="auth-cover-card-wrapper">
            <div class="auth-cover-card p-sm-5">
              <div class="wd-50 mb-5">
                <img src="assets/images/crm-logo-small.png" class="img-fluid" />
              </div>
              <h2 class="fs-20 fw-bolder mb-4">Giriş Yap</h2>
              <h4 class="fs-13 fw-bold mb-2">Hesabınıza giriş yapın</h4>
              <form onSubmit={handleSubmit} className="w-100 mt-4 pt-2">
                <div class="mb-4">
                  <input
                    type="email"
                    class="form-control"
                    placeholder="E-Posta Adresi"
                    required
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div class="mb-3">
                  <input
                    type="password"
                    class="form-control"
                    placeholder="Şifre"
                    required
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                <div class="mt-5">
                  <button type="submit" class="btn btn-lg btn-primary w-100">
                    Giriş Yap
                  </button>
                </div>
              </form>
              <div class="w-100 mt-5 text-center mx-auto">
                <div class="d-flex align-items-center justify-content-center gap-2">
                  <a
                    href="https://levelupcrm.com.tr"
                    target="_blank"
                    class="btn btn-light-brand flex-fill"
                    data-bs-toggle="tooltip"
                    data-bs-trigger="hover"
                    title="Levelup CRM Web Sitesi"
                  >
                    <i class="feather-globe me-2"></i>
                    Levelup CRM
                  </a>
                  <a
                    href="https://levelupagency.com.tr"
                    target="_blank"
                    class="btn btn-light-brand flex-fill"
                    data-bs-toggle="tooltip"
                    data-bs-trigger="hover"
                    title="Levelup Agency Web Sitesi"
                  >
                    <i class="feather-globe me-2"></i>
                    Levelup Agency
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};

export default Login;
